import styled from 'styled-components';

export const SingleJobBody = styled.div`
  margin: -4rem auto 0;
  padding-bottom: 5rem;
  max-width: 1140px;
  width: 100%;
  
  .application-process {
    & .coming-soon {
      p {
        text-align: left;
      }
    }
  }
`;

export const JobContentGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
  
  /* Single column on tablets and mobile */
  @media (max-width: 1199px) {
    grid-template-columns: 1fr;
  }
  
  /* Auto-fit for dynamic sections */
  &.auto-fit {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  }
  
  /* Full width sections */
  .full-width {
    grid-column: 1 / -1;
  }
`;

export const JobActivitiesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
  margin-bottom: 16px;
  
  /* Ensure minimum 2 columns on desktop, 1 on mobile */
  @media (min-width: 1200px) {
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  }
  
  @media (max-width: 767px) {
    grid-template-columns: 1fr;
  }
`;

export const InterviewDescription = styled.p`
  margin-bottom: 32px;
`;

export const ApplicationProcessWrap = styled.div`
  max-width: 752px;
`;
